import '../scss/main.scss';
import '../scss/config/tailwind.config.css';
import './menu.js';
//import './audio.js';
import './klazy.js';
import './animate.js';
//import './vest.js';
//import './download.js';
import { initLenis } from './lenis.js';
import './hero-animation.js';
import './bsport.js';

initLenis();